// NPM Requirements
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// Selectors
import { getCityConfig } from '../../../selectors';

class Contact extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { cityConfig } = this.props;

    return (
      <div className="Box Box--white u-limitWidth30">
        <p>Text or call</p>
        <h3><a href="tel:2067990095">(206) 799-0095</a></h3>
        <p>Email us</p>
        <h3><a href={"mailto:" + cityConfig.support_email}>{cityConfig.support_email}</a></h3>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    cityConfig: getCityConfig(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Contact));
